import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { startCase } from "lodash";
import { useState } from "react";

const RBACTable = () => {
  const [expanded, setExpanded] = useState<{
    [key: string]: boolean;
  }>({ CUSTOMER_PROFILE: false, APPOINTMENTS: false, CONFIGURATION: false });

  const MODULES = [
    { title: "CUSTOMER_PROFILE", pages: ["SEARCH_CUSTOMER", "DETAILS_CUSTOMER", "ADD_CUSTOMER", "CUSTOMER_EMR"] },
    {
      title: "APPOINTMENTS",
      pages: [
        "OVERBOOKING",
        "CHECK_SLOTS",
        "CHECK_BOOKED_SLOTS",
        "CHECK_AVAILABLE_SLOTS",
        "HAIRCUT_TO_BATH",
        "APPOINTMENT_SHIFT",
      ],
    },
    { title: "CONFIGURATION", pages: ["CITY_SETUP", "CITY_ONBOARD", "STAFF_SETUP", "STAFF_ONBOARD"] },
  ];

  const ACTIONS = [
    { title: "ADD_CUSTOMER", displayName: "Add Customer", description: "Adding of customer in VMS" },
    { title: "EDIT_PET", displayName: "Add Customer", description: "Adding of customer in VMS" },
    { title: "EDIT_CUSTOMER", displayName: "Add Customer", description: "Adding of customer in VMS" },
    { title: "ADD_PET", displayName: "Add Customer", description: "Adding of customer in VMS" },
    { title: "RESCHEDULE_APPOINTMENT", displayName: "Add Customer", description: "Adding of customer in VMS" },
    { title: "CANCEL_APPOINTMENT", displayName: "Add Customer", description: "Adding of customer in VMS" },
    { title: "BOOK_APPOINTMENT", displayName: "Add Customer", description: "Adding of customer in VMS" },
  ];

  const getModulePages = (moduleId: string) => {
    return MODULES?.filter((m) => m.title === moduleId)[0]?.pages;
  };

  return (
    <table className="w-10/12 rounded-md overflow-hidden mt-4">
      <thead className="bg-gray-50 ">
        <th className="text-sm text-center">Modules</th>
        {ACTIONS?.map((action) => {
          return (
            <th className="text-xs font-normal h-14" key={action.title}>
              <div className="flex justify-start items-center gap-x-2">
                <input type="checkbox" className="rounded-md " />
                {startCase(action.title?.split("-")?.join("")?.toLowerCase())}
              </div>
            </th>
          );
        })}
      </thead>
      <tbody>
        {MODULES?.map((module) => {
          return (
            <>
              <tr className="py-2 bg-blue-50">
                <td className="text-xs py-2">
                  <div className="flex justify-start items-center gap-x-1 pl-2">
                    {startCase(module.title?.split("-")?.join("")?.toLowerCase())}
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setExpanded((prev) => {
                          return { ...prev, [`${module.title}`]: !prev[module.title] };
                        });
                      }}
                    >
                      {expanded[module.title] ? (
                        <ChevronDownIcon className="w-4 h-4" />
                      ) : (
                        <ChevronUpIcon className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </td>
                {ACTIONS?.map((action, idx) => {
                  return <td className="text-left" key={`${action.title}:${idx}`}></td>;
                })}
              </tr>
              {expanded[module.title] &&
                getModulePages(module.title)?.map((page, idx) => {
                  return (
                    <tr key={`${page}:${idx}`}>
                      <td className="text-xs text-gray-600 py-2 text-right pl-2 pr-2">
                        <div className="flex justify-between items-center gap-x-1">
                          {startCase(page?.split("_")?.join(" ")?.toLowerCase())}
                        </div>
                      </td>
                      {ACTIONS?.map((action, idx) => {
                        return (
                          <td className="text-left" key={`${page}:${action.title}:${idx}`}>
                            <input type="checkbox" className="rounded-md" />
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </>
          );
        })}
      </tbody>
    </table>
  );
};

export default RBACTable;
